/** @jsx jsx */
import { cssMap, jsx } from '@compiled/react';
import IconOpen from '@atlaskit/icon/core/migration/arrow-up-right--open';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '../item/index.tsx';
import messages from './messages.tsx';
import type { MenuItemViewAllProps } from './types.tsx';

const styles = cssMap({
	viewAll: {
		color: token('color.link'),
		textDecoration: 'none',
		'&:hover, &:focus': {
			color: token('color.link'),
			textDecoration: 'none',
		},
		'&:active': {
			color: token('color.link.pressed'),
			textDecoration: 'none',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		span: {
			color: token('color.link'),
			textDecoration: 'none',
		},
	},
});

export const MenuItemViewAll = (props: MenuItemViewAllProps) => {
	const { formatMessage } = useIntl();

	return (
		<MenuItem
			{...props}
			target="_blank"
			css={styles.viewAll}
			iconAfter={<IconOpen spacing="spacious" label={formatMessage(messages.viewAllStarred)} />}
		>
			{formatMessage(messages.viewAllStarred)}
		</MenuItem>
	);
};
